
// src/helpers/field-icons.js

const FIELD_ICONS = {
  'time': 'access_time',
  'date': 'date_range',
  'text': 'create',
  'string': 'create',
  'numeric': 'create',
  'dropdown': 'arrow_drop_down',
}

export default FIELD_ICONS



// WEBPACK FOOTER //
// ./src/helpers/field-icons.js